'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _server = require('react-dom/server');

var _server2 = _interopRequireDefault(_server);

var _hypernova = require('hypernova');

var _hypernova2 = _interopRequireDefault(_hypernova);

var _reactRedux = require('react-redux');

var _performQueries = require('./performQueries');

var _performQueries2 = _interopRequireDefault(_performQueries);

var _withQueries = require('./withQueries');

var _withQueries2 = _interopRequireDefault(_withQueries);

var _createStore = require('./createStore');

var _createStore2 = _interopRequireDefault(_createStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var section = function section(_ref) {
  var name = _ref.name,
      component = _ref.component,
      _ref$queries = _ref.queries,
      queries = _ref$queries === undefined ? [] : _ref$queries,
      _ref$actions = _ref.actions,
      actions = _ref$actions === undefined ? [] : _ref$actions;

  var ComponentWithQueries = (0, _withQueries2.default)({ queries: queries, actions: actions })(component);

  return (0, _hypernova2.default)({
    server: function server() {
      return function (_ref2) {
        var props = _ref2.props,
            ctx = _ref2.ctx;

        var store = (0, _createStore2.default)(undefined, ctx.root + '/' + ctx.path, ctx.id);

        return (0, _performQueries2.default)(ComponentWithQueries, store).then(function () {
          var contents = _server2.default.renderToString(buildProvider(ComponentWithQueries, store, props));
          return (0, _hypernova.serialize)(name, contents, { props: props, ctx: ctx, state: store.getState() });
        });
      };
    },

    client: function client() {
      require('domready')(function () {
        var payloads = (0, _hypernova.load)(name);

        if (payloads) {
          payloads.forEach(function (payload) {
            var node = payload.node,
                _payload$data = payload.data,
                state = _payload$data.state,
                props = _payload$data.props,
                ctx = _payload$data.ctx;

            var root = '' + window.location.origin + window.location.pathname;
            var store = (0, _createStore2.default)(state, root, ctx.id);
            var element = _react2.default.createElement(ComponentWithQueries, props);

            _reactDom2.default.render(buildProvider(element, store), node);
          });
        }
      });

      return ComponentWithQueries;
    }
  });
};

var buildProvider = function buildProvider(component, store) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.isValidElement(component) ? component : _react2.default.createElement(component, props)
  );
};

exports.default = section;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@jump/pages/lib/section.js
// module id = 263
// module chunks = 0